import React from 'react'
import { MenuItemType } from '@utils/types'
import { Button, WImage, WLink } from '@components/atoms'
import styles from './NavCard.module.sass'

interface Props {
  item: MenuItemType
  className?: string
  onClick?: () => void
}

const NavCard = (props: Props) => {
  const { item = undefined, className = '', onClick = undefined } = props

  const getContent = () => (
    <>
      <div className={`${styles.imageBox}`}>
        {!!item.image && (
          <WImage
            src={item.image}
            maxWidth={85}
            maxHeight={85}
            objectFit="cover"
            alt={item?.imageAlt}
            title={item?.imageAlt}
          />
        )}
      </div>
      <div className={styles.main}>
        {!!item.name && <p className={styles.title}>{item.name}</p>}
        {!!item.ctaLabel && !!item.url && <Button label={item.ctaLabel} variant={'ghost'} />}
      </div>
    </>
  )

  return item ? (
    item?.url ? (
      <WLink
        href={item.url}
        newPage={item.blank}
        className={`${styles.root} ${className}`}
        onClick={onClick}
      >
        {getContent()}
      </WLink>
    ) : (
      <div className={`${styles.root} ${className}`}>{getContent()}</div>
    )
  ) : (
    <></>
  )
}

export default NavCard
